import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';
import Decimal from 'decimal.js';
import Numeric from '@/core/types/Numeric';
import Qty     from '@/core/types/Qty';
import Volume  from '@/core/types/Volume';
import Density from '@/core/types/Density';
import NumberUtils from "@/core/utils/NumberUtils";
import Unit        from '@/domains/Units/Unit';

/**
 * Вес. Точность — 1 знак.
 *
 * Единица — КИЛОГРАММЫ.
 *
 * Зеркальный бекенд: core/types/Weight.php на BcMath\Number.
 */
@Title_ru_RU_Class('Вес')
class Weight extends Numeric {
    protected static readonly SCALE = 1;

    static fromServer(value: string): Weight {
        return new Weight(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): Weight {
        return new Weight(value);
    }

    /** Вес нетто + вес палеты = вес брутто. */
    plus(other: Weight | null | undefined): Weight {
        return Weight.fromOperation(this.value.plus(Weight.toDecimal(other)));
    }

    /** Масса (ед. груза) × количество = общая масса (паллетоместа). */
    mul(qty: Qty | null | undefined): Weight {
        return Weight.fromOperation(this.value.times(Weight.toDecimal(qty)));
    }

    /** Вычисление плотности (кг на м³). */
    div(volume: Volume | null | undefined): Density {
        return Density.fromOperation(this.value.dividedBy(Weight.toDecimal(volume)));
    }

    /** Вес показываем с точностью типа (1 знак) без разделителей разрядов:
     * дробные граммы не нужны, группировка тысяч тоже. Пустое значение —
     * пустая строка, не "NaN".
     * @param unit - единица измерения (имя клеится постфиксом; null — без единицы)
     */
    format(unit: Unit | null = null): string {
      if (this.isEmpty()) {
        return '';
      }

      let result = NumberUtils.formatDecimal(this.value, this.scale);

      if (unit) {
        result += `\u00A0${unit.name}`;
      }

      return result;
    }
}

export default Weight;